import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RealexJourney } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/realexProvider/RealexJourney';
import { PraxisJourney } from './praxisProvider/PraxisJourney';
import { PaysafeJourney } from './paysafeProvider/PaysafeJourney';
import { OperatorTurnOffDeposits } from './topUpProcedureParts/depositFailure/OperatorTurnOffDeposits';
import { ResponsibleGamblingLinks } from 'src/domains/players/webview/components/Account/responsibleGamblingLinks/responsibleGamblingLinks';
import { DepositContainer } from './DepositProcedure.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { MultiDepositJourney } from './multiDepositJourney/MultiDepositJourney';

export const DepositProcedureProvider = observer('DepositProcedureProvider', (): JSX.Element | null => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { depositsTurnOffForLeavingOperator, isSaferGambling, paymentProviders } = configState;
    const viewJourney = paymentProviders.isNewPaymentJourneyEnabled ? 'multi-deposit' : paymentProviders.debitCard.type;
    const isClosing =
        configState.closureModeWithLogin || configState.closureMode || configState.midnightMigrationScreen;
    if (depositsTurnOffForLeavingOperator.enabled) {
        return (
            <OperatorTurnOffDeposits
                operatorName={depositsTurnOffForLeavingOperator.operatorName}
                isSignup={false}
                date={depositsTurnOffForLeavingOperator.date}
            />
        );
    }
    if (isClosing) {
        return null;
    }
    const renderContent = (): JSX.Element => {
        switch (viewJourney) {
            case 'realex':
                return <RealexJourney isSignup={false} />;
            case 'praxis':
                return <PraxisJourney isSignup={false} />;
            case 'paysafe':
                return <PaysafeJourney isSignup={false} />;
            case 'multi-deposit':
                return <MultiDepositJourney isSignup={false} />;
            case null:
                return <div />;
        }
    };

    return (
        <DepositContainer>
            {renderContent()}
            {isSaferGambling.available === true ? <ResponsibleGamblingLinks type='primary' /> : null}
        </DepositContainer>
    );
});
